import api from 'src/api/api';

export const SET_PATIENT = '@patient/set-patient';
export const SET_AUDIPHONE = '@patient/set-hearingDevice';
export const SET_AUDIPHONE_SETTING = '@patient/set-hearingDevice-setting';
export const SET_ACOUSTICS_CHART_DATA = '@patient/set-acoustics-chart-data';
export const SET_ACOUSTICS_CHART_SETTING = '@patient/set-acoustics-chart-setting';
export const SET_ALL_ACOUSTICS_CHART_SETTING = '@patient/set-all-acoustics-chart-setting';

export const SET_ADJUST_TYPE = 'set_adjust_type';
export const SET_SHOW_GAIN_THRESHOLD = 'setShowGainThreshold';
export const SET_ADJUST_TYPE_IN_TYPE = 'setAdjustmentTypeInType';
export const SET_IO_RATE = 'setIORate';
export const SET_OPEN_SOUND_RECOVER_2 = 'setOpenSoundRecover2';

export const SET_GAIN_CHART_POINTS = 'SET_GAIN_CHART_POINTS';
export const SET_OPEN_SOUND_RECOVER_RATE_RANGE = 'setOpenSoundRecoverRate';

export function setPatient(patient) {
  return (dispatch) => {
    dispatch({
      type: SET_PATIENT,
      payload: { patient }
    });
  };
}

export const SET_SESSIONS = "setSessions";
export function setSessions(sessions) {
  return (dispatch) => {
    dispatch({
      type: SET_SESSIONS,
      payload: { sessions }
    });
  };
}

export function setHearingDevice(type, hearinginstrument, hearinginstrumentOther = undefined) {
  return (dispatch) => {
    api.getHearingDevice().then((data) => {
      dispatch({
        type: SET_AUDIPHONE,
        payload: { type, hearinginstrument, hearinginstrumentOther, data }
      });
    });
  };
}

export function setHearingDeviceSetting(type, setting) {
  return (dispatch) => {
    dispatch({
      type: SET_AUDIPHONE_SETTING,
      payload: { type, setting }
    });
  };
}

export function setAcousticsChartData(type, chartIndex, lineIndex, points) {
  return (dispatch) => {
    dispatch({
      type: SET_ACOUSTICS_CHART_DATA,
      payload: { type, chartIndex, lineIndex, points }
    });
  };
}

export function setAcousticsChartSetting(type, chartIndex, setting) {
  return (dispatch) => {
    dispatch({
      type: SET_ACOUSTICS_CHART_SETTING,
      payload: { type, chartIndex, setting }
    });
  };
}
export function setAllAcousticsChartSetting(type, index, setting, setting2) {
  return (dispatch) => {
    dispatch({
      type: SET_ALL_ACOUSTICS_CHART_SETTING,
      payload: { type, index, setting, setting2 }
    });
  };
}

export const SET_ALL_CHART = "setAllChart";
export function setAllChart(type, data, data2, ids) {
  return (dispatch) => {
    dispatch({
      type: SET_ALL_CHART,
      payload: { type, data, data2, ids }
    });
  };
}

export function setAdjustmentType(type) {
  return (dispatch) => {
    dispatch({
      type: SET_ADJUST_TYPE,
      payload: { type }
    });
  };
}

export function setShowGainThreshold(show) {
  return (dispatch) => {
    dispatch({
      type: SET_SHOW_GAIN_THRESHOLD,
      payload: { show }
    });
  };
}

export function setAdjustmentTypeInType(type, inType) {
  return (dispatch) => {
    dispatch({
      type: SET_ADJUST_TYPE_IN_TYPE,
      payload: { type, inType }
    });
  };
}

export function setIORate(rate) {
  return (dispatch) => {
    dispatch({
      type: SET_IO_RATE,
      payload: rate
    });
  };
}
export function setGainChartPoints(leftData, rightData) {
  return (dispatch) => {
    dispatch({
      type: SET_GAIN_CHART_POINTS,
      payload: { leftData, rightData }
    });
  };
}


export function setOpenSoundRecover2(type, isOpen) {
  return (dispatch) => {
    dispatch({
      type: SET_OPEN_SOUND_RECOVER_2,
      payload: { type, isOpen }
    });
  };
}

export function setOpenSoundRecoverRate(type, range) {
  return (dispatch) => {
    dispatch({
      type: SET_OPEN_SOUND_RECOVER_RATE_RANGE,
      payload: { type, range }
    });
  };
}

export const SET_USER_NOISE_GENERATOR = "setUseNoiseGenerator";

export function setUseNoiseGenerator(type, useNoiseGenerator) {
  return (dispatch) => {
    dispatch({
      type: SET_USER_NOISE_GENERATOR,
      payload: { type, useNoiseGenerator }
    });
  };
}
export const SET_FEEDBACK_REALEARTEST_OVERTUNING = "setFeedbackRealEarTestOvertuning";

export function setFeedbackRealEarTestOvertuning(type, overtuning) {
  return (dispatch) => {
    dispatch({
      type: SET_FEEDBACK_REALEARTEST_OVERTUNING,
      payload: { type, overtuning }
    });
  };
}

export const SET_HI_CONFIGURATION = "setHIConfiguration";

export function setHIConfiguration(data) {
  return (dispatch) => {
    dispatch({
      type: SET_HI_CONFIGURATION,
      payload: { data }
    });
  };
}
export const SET_HI_DETAIL = "setHIDetail";

export function setHIDetail(data) {
  return (dispatch) => {
    dispatch({
      type: SET_HI_DETAIL,
      payload: { data }
    });
  };
}
export const SET_HI_IMAGE = "setHIImage";

export function setHIImage(left, right) {
  return (dispatch) => {
    dispatch({
      type: SET_HI_IMAGE,
      payload: { left, right }
    });
  };
}

export const CLEAR_PATIENT = "clearPatient";
export function clearPatient(side) {
  return (dispatch) => {
    dispatch({
      type: CLEAR_PATIENT,
      payload: { side }
    });
  };
}

export const SET_DETAIL_COLOR_VALUE = "setHiDetailColorValue";
export function setHiDetailColorValue(side, key, value) {
  return (dispatch) => {
    dispatch({
      type: SET_DETAIL_COLOR_VALUE,
      payload: { side, key, value }
    });
  };
};